import { DangerousHtmlContent } from '@eti/components';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';

const trustInformationWrapperStyles = css`
  border-left: 4px solid ${etiColors.info.focus};
  color: ${etiColors.black};
  font-size: 0.75rem;
  padding: 2px 5px;

  @media ${mediaQueries.medium.up} {
    font-size: 0.875rem;
  }

  html[dir='rtl'] & {
    border-left: none;
    border-right: 4px solid ${etiColors.info.focus};
  }
`;

const headerStyles = css`
  font-weight: 700;
`;

interface TrustInformationProps {
  className: string;
  content: string;
  header: string;
}

const TrustInformation = ({ className, content, header }: TrustInformationProps) => (
  <div className={cx(trustInformationWrapperStyles, className)}>
    <div className={headerStyles}>{header}</div>
    <DangerousHtmlContent content={content} />
  </div>
);

export default TrustInformation;
